<template>
	<div id="HeaderMenu" class="hasFixed">
		<div class="btnlist">
			<div class="item" style="margin-left: 20px;">
				<el-image style="width: 50px;height: 50px;" :src="require('../assets/icon.png')" ></el-image>
			</div>
			<!-- <div class="item" style="flex: 1;">
			</div> -->
			<div class="item">
				<div class='menu__link' @click="toHome">主页</div>
			</div>
			<div class="item">
				<div class='menu__link' @click="toOmission">留白空间</div>
			</div>
			<div class="item">
				<div class='menu__link' @click="toMeeting">留白会议</div>
			</div>
			<!-- 			<div class="item">
				<div class='menu__link'>联系我们</div>
			</div> -->
			<div class="item" style="flex: 1;">
			</div>
			<!-- <a href="#section3"><span></span>Scroll</a> -->
			<div class="item">
				<a class='menu__link' href="#section3">用户案例</a>
			</div>
			<div class="item">
				<side-menu></side-menu>
			</div>
		</div>

		<!-- <div class="line"></div> -->

	</div>
</template>

<script>
	import SideMenu from "./SideMenu.vue";
	export default {
		name: "HeaderMenu",
		data() {
			return {
				activeIndex: '1',
				activeIndex2: '1',
				// needFixed:true
			};
		},
		// mounted() {
		// 	window.addEventListener('scroll', this.handleScroll)
		// },
		// destroyed () {
		//       window.removeEventListener('scroll', this.handleScroll)
		//     },
		components: {
			SideMenu
		},
		methods: {
			toHome() {
				window.location.href = "https://omissionvr.com/"
			},
			toOmission() {
				window.location.href = "https://omissionvr.com/vue"
			},
			toMeeting() {
				window.location.href = "https://omissionvr.com/screen"
			},
			// handleScroll() {
			// 	let self = this
			// 	let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			// 	console.log(scrollTop)
			// 	// if (scrollTop > 60) {
			// 	//       self.needFixed = true;
			// 	//    } else {
			// 	//       self.needFixed = false;
			// 	//    }
			// },
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
			}
		}
	}
</script>

<style>
	.btn {
		font: .8rem/30px Arial, sans-serif !important;
		font-family: 'Ubuntu', Helvetica, Arial, sans-serif !important;
		
	}

	.hasFixed {
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		background: #FFFFFF;
		/* z-index: 1000; //视情况而定，需不需要 */
	}

	.t {
		/* background-color: transparent; */
	}

	.btnlist {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.btnitem {
		display: block;
		margin: 1em 0;
		margin: 0 .5em;
	}

	.menu__link {
		font-family: 'Lato';
		font-weight: 1000;
		font-size: 1em;
		display: block;
		padding: .5em 2em;
		cursor: pointer;
		user-select: none;
		-webkit-touch-callout: none;
		-khtml-user-select: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		position: relative;
		text-align: center;
		color: #161616;
		background: none;
		border: none;
		text-decoration: none;
		text-transform: uppercase;
		transition: color 0.3s;
	}

	.menu__link:hover,
	.menu__link:focus {
		outline: none;
		color: #EB4E89;
	}

	.menu__item--current .menu__link {
		color: #77D6E2;
	}

	.menu__link:before,
	.menu__link:after {
		content: '';
		position: absolute;
		width: 10px;
		height: 10px;
		opacity: 0;
		border: 2px solid $pink;
		transition: transform 0.3s, opacity 0.3s;
		transition-timing-function: cubic-bezier(0.17, 0.67, 0.05, 1.29);
	}

	.menu__link:before {
		top: 0;
		left: 0;
		border-width: 2px 0 0 2px;
		transform: translate3d(10px, 10px, 0);
	}

	.menu__link:after {
		right: 0;
		bottom: 0;
		border-width: 0 2px 2px 0;
		transform: translate3d(-10px, -10px, 0);
	}

	.menu__item--current .menu__link:before,
	.menu__item--current .menu__link:after {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
</style>
